import { addDays } from './period.js';
export const FORECAST_HORIZONS = ['60', '90', '120'];
/** Факт показываем от 5 покупок. */
export const FACT_MIN_N = 5;
/** Факт за H дней созрел, если срок прожили ≥ 90 % покупок корзины (дня, недели, месяца). */
export const FACT_READY_SHARE = 0.9;
/** Покупка «созревает» для горизонта H через H + 3 дня (факт приходит с запасом). */
export const FACT_MATURITY_LAG_DAYS = 3;
const ok = (x) => typeof x === 'number' && Number.isFinite(x);
/** Факт за H дней корзины шага — одна и та же величина во всех отчётах. */
export function factPoint(row, h) {
    const f = row.group.factHorizons[h];
    const expectedFrom = addDays(row.to, Number(h) + FACT_MATURITY_LAG_DAYS);
    if (!f || !ok(f.factRoas) || f.factN < FACT_MIN_N) {
        return {
            state: 'none',
            roas: null,
            share: f?.factShare ?? null,
            n: f?.factN ?? 0,
            thinRoas: f && ok(f.factRoas) && f.factN > 0 ? f.factRoas : null,
            expectedFrom,
        };
    }
    const share = f.factShare;
    return {
        state: ok(share) && share >= FACT_READY_SHARE ? 'mature' : 'partial',
        roas: f.factRoas,
        share,
        n: f.factN,
        thinRoas: null,
        expectedFrom,
    };
}
/**
 * Факта по корзине не будет никогда или уже не стоит его ждать: покупок
 * меньше 5 (порог факта) или срок созревания прошёл, а факта по ≥ 5 покупкам
 * так и нет. Клетка тогда пишет «мало покупок для факта», а не «ещё нет».
 */
export function factTooFew(w, today) {
    if (w.fact.state !== 'none' || w.purchases === 0)
        return false;
    return w.purchases < FACT_MIN_N || (w.fact.thinRoas !== null && w.fact.expectedFrom <= today);
}
/**
 * Когда появится первый созревший факт: самая ранняя корзина с покупками без
 * созревшего факта, её `expectedFrom`. Нет таких корзин — `null`.
 */
export function firstPendingFactFrom(weeks) {
    const d = weeks
        .filter((w) => w.purchases > 0 && w.fact.state !== 'mature')
        .map((w) => w.fact.expectedFrom)
        .sort();
    return d[0] ?? null;
}
/**
 * Срок доступен (кнопка 60 / 90 / 120 активна): есть хотя бы одна неделя с
 * СОЗРЕВШИМ фактом (≥ 90 % покупок прожили срок). Одно правило для «Сбывается
 * ли прогноз» и «Точности» — иначе один блок говорит «факта ещё нет», а
 * соседний его показывает.
 */
export function horizonHasMatureFact(weeks) {
    return weeks.some((w) => w.fact.state === 'mature');
}
//# sourceMappingURL=fact-maturity.js.map